import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useDispatch } from "react-redux";
import api, { imageapi } from "./Api/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Carousel } from "react-responsive-carousel";
import { FaHome, FaBusinessTime, FaPlane } from "react-icons/fa";
import { MdSpaceDashboard } from "react-icons/md";
import { GiBoxUnpacking } from "react-icons/gi";
import { Helmet } from "react-helmet-async";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";

const Main = () => {
  const prevScrollY = useRef(0);
  const [goingUp, setGoingUp] = useState(false);
  const [index, setIndex] = useState(0);
  const dispatch = useDispatch();
   const navigate = useNavigate();

  const {
    data: servicedata,

    refetch,
  } = useQuery(["services"], () => api.get(`users/getservices`), {
    select: (res) => res.data,
  });

  const { data: bannerdata } = useQuery(
    ["banners"],
    () => api.get(`users/getbanners`),
    {
      select: (res) => res.data,
    }
  );

  const { data: aboutusdata } = useQuery(
    ["aboutus"],
    () => api.get(`users/aboutus`),
    {
      select: (res) => res.data,
    }
  );

  // const mutationbanner = useMutation(
  //   (body) => {
  //     const headers = {
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //     };
  //     return api.post("users/getbanners", body, headers);
  //   },
  //   {
  //     onError: (error, variables, context) => {
  //       console.log(error);
  //     },
  //     onSuccess: (data, variables, context) => {
  //       setBannerData(data?.data);
  //     },
  //   }
  // );

  // useEffect(()=>{
  // window.location.reload()
  // },[])

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;
      console.log(goingUp, currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("refresh"))) {
      window.location.reload();
      localStorage.setItem("refresh", JSON.stringify(0));
    }
  }, []);

  const handleClick = (item) => {
    dispatch({ type: "ADD_SERVICES", payload: item });

    // Save service type to localStorage
    localStorage.setItem("service_type", item.type);
    console.log("Service type saved:", item.type);
  };

  let services = servicedata?.data.sort((a, b) => b.priority - a.priority);
  services = services?.filter((item) => item.isHome == 1);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  var settingServices = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  //  Packing Inquiry Form Mutation
const packingInquiryMutation = useMutation(
  (body) => {
    return api.post("/packing/packing-inquiry", body);
  },
  {
    onError: (error) => {
      console.error("Packing inquiry error:", error);
      // toast.error("Failed to submit inquiry. Please try again.");
    },
    onSuccess: (response) => {
      console.log("Packing inquiry submitted:", response.data);
      // toast.success("Thank you! Your inquiry has been submitted successfully.");
      // Reset form
      document.getElementById("packingInquiryForm").reset();
       navigate("/Thankyou");
    },
  }
);

//  Handle Form Submit
const handlePackingInquirySubmit = (e) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  
  const data = {
    name: formData.get("name"),
    phone: formData.get("phone"),
    email: formData.get("email"),
    packing_date: formData.get("packing_date"),
    note: formData.get("note") || null,
  };

  packingInquiryMutation.mutate(data);
};

  return (
    <>
      <Helmet>
        <title>Eco-Friendly Packing Materials | South London Removals </title>
        <meta
          name="title"
          content="Eco-Friendly Packing Materials | South London Removals	"
        />
        <meta
          name="keywords"
          content="top-grade and eco-friendly packing materials, packing materials, Order boxes, Best Packing Materials for Moving"
        />
        <meta
          name="description"
          content="South London Removals offers top-grade and eco-friendly packing materials to secure your belongings during the move. Order boxes, tapes & more at great prices.	"
        />
      </Helmet>

      <div>
        <div class="Products-inner-banner">
          <div class="Products-inner-banner-img">
            <div>
              <div>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="Products-banner-sections">
                      <div class="container">
                        <div class="row align-items-center">
                          {bannerdata?.status &&
                            bannerdata?.data?.length > 0 && (
                              <div class="col-md-6">
                                <h2>{bannerdata.data[0].title}</h2>
                                <p>{bannerdata.data[0].tagline}</p>
                              </div>
                            )}
                          <div class="col-md-6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="delivery-sections">
          <div class="container">
            <div class="heading">
              <h2 align="center">Our Eco-Friendly Packaging Materials</h2>
            </div>

            <div class="MultiCarousel delivery-sections">
              <div class="MultiCarousel-inner">
                {services?.map((item, index) => {
                  return (
                    <div class="item" key={index}>
                      <div class="pad15">
                        <div class="Products-catagory-sections">
                          <Link to={`/${item.slug}`}>
                            <div
                              class="packing-box"
                              onClick={() => handleClick(item)}
                            >
                              <img
                                src={`${imageapi}images/${item.picture}`}
                                alt="image"
                              />
                              <h4>{item.name}</h4>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="new-form">
          <div class="heading">
              <h2 align="center" style={{color:'#fff'}}>Enquiry For Packing Service</h2>
            </div>
          <Form id="packingInquiryForm" onSubmit={handlePackingInquirySubmit}>
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter name"
                      required
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      placeholder="Enter phone"
                      required
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter email"
                      required
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Date for packing service</Form.Label>
                    <Form.Control type="date" name="packing_date" required />
                  </Form.Group>
                </div>
                <div className="col-md-12 mb-3">
                  <Form.Label>Note</Form.Label>
                  <br />
                  <textarea
                    name="note"
                    // placeholder="Enter any additional notes..."
                  ></textarea>
                </div>
                <div className="col-md-12 text-center">
                  <Button
                    className="btn2s"
                    variant="primary"
                    type="submit"
                    disabled={packingInquiryMutation.isLoading}
                  >
                    {packingInquiryMutation.isLoading
                      ? "Submitting..."
                      : "Submit"}
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>

        <div className="service-section desktopServices">
          <div className="container-fluid">
            <div class="heading">
              <h2 align="center">Other Services</h2>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-6 p-0">
                    <div className="s-sections im-1">
                      <img src="/images/s1.png" />
                    </div>
                  </div>
                  <div className="col-md-6 p-0">
                    <div className="service-content2 bg-blue">
                      <div>
                        <FaHome />
                        <h3>UK Home Removal Service</h3>
                        <p>
                          At South London Removals, we offer efficient and
                          affordable house removal services in London and across
                          the UK. Our team of expert packers and movers ensures
                          that your home removal process is personalised to your
                          requirements and hassle-free. Trust us with your
                          personal belongings for a reliable packing service and
                          home relocation throughout the UK.
                        </p>
                        <div className="b-btn">
                          <button
                            class="button"
                            style={{
                              background: "#fff",
                              color: "#154060",
                              fontWeight: "bolder",
                            }}
                          >
                            <span>
                              <a href="https://southlondonremovals.uk/home-removals-london/">
                                Read More
                              </a>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 p-0">
                    <div
                      className="service-content2 bg-green"
                      style={{ background: "#154060" }}
                    >
                      <div>
                        <FaBusinessTime />
                        <h3>UK Business & Commercial Moves</h3>
                        <p>
                          From small-scale office relocations to significant
                          commercial moves, at South London Removals, we offer
                          tailored business relocation solutions, including
                          storage services, insurance coverage, and expert
                          support. Choose us for affordable and hassle-free
                          business relocation services customised to your
                          specific business requirements.
                        </p>
                        <div className="b-btn">
                          <button
                            class="button"
                            style={{
                              background: "#fff",
                              color: "#154060",
                              fontWeight: "bolder",
                            }}
                          >
                            <span>
                              <a href="https://southlondonremovals.uk/business-movers-london/">
                                Read More
                              </a>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 p-0">
                    <div className="s-sections im-2">
                      <img src="/images/business.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 p-0">
                <div className="service-bg bg-blue">
                  <div>
                    <FaPlane />
                    <h3>International Moves</h3>
                    <p>
                      Planning to relocate your home or business abroad? We
                      offer affordable international removal services across the
                      UK, Europe and Latin America. Our comprehensive
                      pack-and-move solutions include land, air, and sea
                      transport, ensuring a seamless transition across borders.
                      Whether you need home moving services or business
                      relocations, trust South London Removals' expertise for a
                      reliable and stress-free international relocation.
                    </p>
                    <div className="b-btn">
                      <button
                        class="button"
                        style={{
                          background: "#fff",
                          color: "#154060",
                          fontWeight: "bolder",
                        }}
                      >
                        <span>
                          <a href="https://southlondonremovals.uk/international-movers/">
                            Read More
                          </a>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 p-0">
                <div className="service-bg s bg-green">
                  <div>
                    <MdSpaceDashboard />
                    <h3>Storage Services In London</h3>
                    <p>
                      At South London Removals, we offer three flexible and
                      affordable options for your storage needs. Whether you are
                      a resident, a student, or a small business owner, looking
                      for a secure storage unit, we are here to help. With 24/7
                      CCTV monitoring, our storage units are affordable and
                      ideal for both residential and commercial needs. We also
                      assist with moving and dismantling your items before
                      placing them into storage.
                    </p>
                    <div className="b-btn">
                      <button
                        class="button"
                        style={{
                          background: "#fff",
                          color: "#154060",
                          fontWeight: "bolder",
                        }}
                      >
                        <span>
                          <a href="https://southlondonremovals.uk/storage-services-london/">
                            Read More
                          </a>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-6 p-0">
                    <div className="s-sections im-3">
                      <img src="/images/f.png" />
                    </div>
                  </div>
                  <div className="col-md-6 p-0">
                    <div
                      className="service-content2 bg-blue"
                      style={{ background: "#154060" }}
                    >
                      <div>
                        <GiBoxUnpacking />
                        <h3>Furniture Delivery in London</h3>
                        <p>
                          Looking for a fast and budget-friendly furniture
                          delivery service in London? At South London Removals,
                          we offer expert furniture delivery solutions tailored
                          to your business needs. Our experienced team ensures a
                          seamless process- whether it’s dismantling,
                          reassembling, or same-day delivery. We’ve worked with
                          brands of all sizes, making us a trusted choice for
                          furniture delivery across London.
                        </p>
                        {/* <p>
                          South London Removals provides an expert furniture
                          delivery solution in London. From furniture
                          dismantling and reassembling services to same-day
                          delivery, we have worked with brands of all sizes and
                          are a trusted choice for furniture delivery in London.
                        </p> */}
                        <div className="b-btn">
                          <button
                            class="button"
                            style={{
                              background: "#fff",
                              color: "#154060",
                              fontWeight: "bolder",
                            }}
                          >
                            <span>
                              <a href="https://southlondonremovals.uk/furniture-removals-london/">
                                Read More
                              </a>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 p-0">
                    <div className="service-content2 bg-green">
                      <div>
                        <GiBoxUnpacking />
                        <h3>Recyclable Packing Materials</h3>
                        <p>
                          At South London Removals, we provide a wide range of
                          packing materials for residents and business owners to
                          meet their packing and moving needs. Our affordable
                          packing materials are eco-friendly, reusable, and
                          ideal for packaging both fragile and heavy items.
                          Contact us to purchase high-quality and sustainable
                          packing products.
                        </p>
                        <div className="b-btn">
                          <button
                            class="button"
                            style={{
                              background: "#fff",
                              color: "#154060",
                              fontWeight: "bolder",
                            }}
                          >
                            <span>
                              <Link
                                href={
                                  "https://packing-material.southlondonremovals.uk/"
                                }
                              >
                                Read More
                              </Link>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 p-0">
                    <div className="s-sections im-4">
                      <img src="/images/p.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="service-section mobileServices">
          <div className="container-fluid">
            <div className="row">
              <Slider {...settingServices}>
                <div className="col-md-6 p-0">
                  <div className="service-content2 home-mobile-banner">
                    <div>
                      <FaHome />
                      <h3>UK Home Removal Service</h3>
                      <p>
                        At South London Removals, we offer efficient and
                        affordable house removal services in London and across
                        the UK. Our team of expert packers and movers ensures
                        that your home removal process is personalised to your
                        requirements and hassle-free. Trust us with your
                        personal belongings for a reliable packing service and
                        home relocation throughout the UK.
                      </p>
                      <div className="b-btn">
                        <button
                          class="button"
                          style={{
                            background: "#fff",
                            color: "#154060",
                            fontWeight: "bolder",
                          }}
                        >
                          <span>
                            <a href="https://southlondonremovals.uk/home-removals-london/">
                              Read More
                            </a>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-0">
                  <div
                    className="service-content2 Business-mobile-banner"
                    style={{ background: "#154060" }}
                  >
                    <div>
                      <FaBusinessTime />
                      <h3>UK Business & Commercial Moves</h3>
                      <p>
                        From small-scale office relocations to large commercial
                        moves, at South London Removals, we offer tailored
                        business relocation solutions, including storage
                        services, insurance coverage, and expert support. Choose
                        us for affordable and hassle-free business relocation
                        services customised to your specific business
                        requirements.
                      </p>
                      <div className="b-btn">
                        <button
                          class="button"
                          style={{
                            background: "#fff",
                            color: "#154060",
                            fontWeight: "bolder",
                          }}
                        >
                          <span>
                            <a href="https://southlondonremovals.uk/business-movers-london/">
                              Read More
                            </a>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-0">
                  <div className="service-content2 international-mobile-banner">
                    <div>
                      <FaPlane />
                      <h3>International Moves</h3>
                      <p>
                        Planning to relocate your home or business abroad? We
                        offer affordable international removal services across
                        the UK, Europe and Latin America. Our comprehensive
                        pack-and-move solutions include land, air, and sea
                        transport, ensuring a seamless transition across
                        borders. Whether you need home moving services or
                        business relocations, trust South London Removals’
                        expertise for a reliable and stress free international
                        relocation.
                      </p>
                      <div className="b-btn">
                        <button
                          class="button"
                          style={{
                            background: "#fff",
                            color: "#154060",
                            fontWeight: "bolder",
                          }}
                        >
                          <span>
                            <a href="https://southlondonremovals.uk/international-movers/">
                              Read More
                            </a>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 p-0">
                  <div className="service-content2 s storage-mobile-banner">
                    <div>
                      <MdSpaceDashboard />
                      <h3>Storage Services In London</h3>
                      <p>
                        At South London Removal, we offer three flexible and
                        affordable options for your storage needs. Whether you
                        are a resident, a student, or a small business owner,
                        looking for a secure storage unit, we are here to help.
                        With 24/7 CCTV monitoring, our storage units are
                        affordable and ideal for both residential and commercial
                        needs. We also assist with moving and dismantling your
                        items before placing them into storage.
                      </p>
                      <div className="b-btn">
                        <button
                          class="button"
                          style={{
                            background: "#fff",
                            color: "#154060",
                            fontWeight: "bolder",
                          }}
                        >
                          <span>
                            <a href="https://southlondonremovals.uk/storage-services-london/">
                              Read More
                            </a>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-0">
                  <div
                    className="service-content2 furniture-mobile-banner"
                    style={{ background: "#154060" }}
                  >
                    <div>
                      <GiBoxUnpacking />
                      <h3>Furniture Delivery in London</h3>
                      <p>
                        Looking for a fast and budget friendly furniture
                        delivery service in London? At South London Removals, we
                        offer expert furniture delivery solutions tailored to
                        your business needs. Our experienced team ensures a
                        seamless process- whether it’s dismantling,
                        reassembling, or same-day delivery. We’ve worked with
                        brands of all sizes, making us a trusted choice for
                        furniture delivery across London.
                      </p>
                      <div className="b-btn">
                        <button
                          class="button"
                          style={{
                            background: "#fff",
                            color: "#154060",
                            fontWeight: "bolder",
                          }}
                        >
                          <span>
                            <a href="https://southlondonremovals.uk/furniture-removals-london/">
                              Read More
                            </a>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-0">
                  <div className="service-content2 packing-mobile-banner">
                    <div>
                      <GiBoxUnpacking />
                      <h3>Recyclable Packing Materials</h3>
                      <p>
                        At South London Removals, we provide a wide range of
                        packing materials for residents and business owners to
                        meet their packing and moving needs. Our affordable
                        packing materials are eco-friendly, reusable, and ideal
                        for packaging both fragile and heavy items. Contact us
                        to purchase high-quality and sustainable packing
                        products.
                      </p>
                      <div className="b-btn">
                        <button
                          class="button"
                          style={{
                            background: "#fff",
                            color: "#154060",
                            fontWeight: "bolder",
                          }}
                        >
                          <span>
                            <a href="https://packing-material.southlondonremovals.uk/">
                              Read More
                            </a>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <form action="/Thankyou">
            <div className="heading">
              <h2
                className="mb-3 text-light"
                style={{
                  color: "#70bf44 !important",
                }}
              >
                Our Team Can Assist You In Your Queries
              </h2>
            </div>
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="mb-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Name"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-4">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Your Email Id"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-4">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Your Phone Number"
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    required
                    placeholder="Enter Your Query"
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="b-btn mt-3">
              <button
                class="button"
                style={{ background: "#154060 !important" }}
              >
                <span>Submit</span>
              </button>
            </div>

            <div className="form-cl mt-3">
              Call Us<a href="tel:02039277675"> 02039277675</a>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Main;
